// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("css/" + chunkId + "." + "f41b49d913f99549cab0" + ".css");